import LeftArrow from '../../images/left-arrow.png';
import RightArrow from '../../images/right-arrow.png';
import './Carousel.scss';
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useEffect, useState } from 'react';
import useWindowDimensions from './WindowDimensions';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

function Carousel({ cards = [], centerMode = false, partialVisbile = false, numberOfCards = 4, tabCards = 3, arrows=true, leftArrow = LeftArrow, rightArrow = RightArrow, showDots = false }) {
    const chevronWidth = 0;
    const [currentCarousel, setCurrentCarousel] = useState(undefined);
    const { width } = useWindowDimensions();
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1025 },
          items: numberOfCards,
          partialVisibilityGutter:0,
          slidesToSlide: numberOfCards
        },
        tablet: {
          breakpoint: { max: 1024, min: 768 },
          items: tabCards,
          slidesToSlide: numberOfCards 
        },
        mobile: {
          breakpoint: { max: 768, min: 0 },
          items: 1,
          partialVisibilityGutter: (width - 300),
          slidesToSlide: 1 
        }
      };
    useEffect(() => {
      centerMode && width <= 1024 && currentCarousel?.goToSlide(1, true);
    }, [centerMode, currentCarousel, width])
    
    return (
        <div className='carousel-wrp' style={{ padding: `0 ${chevronWidth}px` }}>
            <Carousels ref={el => (setCurrentCarousel(el))}
                swipeable={true}
                draggable={false}
                showDots={showDots}
                arrows={arrows}
                responsive={responsive}
                minimumTouchDrag={1}
                partialVisible={partialVisbile}
                centerMode={centerMode}
                ssr={false} // means to render carousel on server-side.
                infinite={false}
                renderArrowsWhenDisabled={true}
                customLeftArrow={<button className='nav-icon left' > <ArrowBack/></button>}
                customRightArrow={<button className='nav-icon right'> <ArrowForward/></button>}
                keyBoardControl={true}
                additionalTransfrom={0}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
            >
                {cards}
            </Carousels>
        </div>
    );
};
export default Carousel;